'use client';

import { Profile } from '@/app/lib/profiles';

interface ChildSelectorProps {
  profiles: Profile[];
  onSelect: (profile: Profile) => void;
}

export default function ChildSelector({ profiles, onSelect }: ChildSelectorProps) {
  return (
    <div className="child-selector">
      <div className="child-selector__card">
        <div className="child-selector__icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M12 2L2 7l10 5 10-5-10-5z" />
            <path d="M2 17l10 5 10-5" />
            <path d="M2 12l10 5 10-5" />
          </svg>
        </div>
        <h1 className="child-selector__title">Study Buddy</h1>
        <p className="child-selector__subtitle">Who&apos;s studying today?</p>
        <div className="child-selector__list">
          {profiles.map((profile) => (
            <button
              key={profile.id}
              type="button"
              className="child-selector__option"
              onClick={() => onSelect(profile)}
            >
              <span className="child-selector__option-name">{profile.name}</span>
              {profile.gradeLevel && (
                <span className="child-selector__option-meta">{profile.gradeLevel}</span>
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
